import PropTypes from 'prop-types'
import React, { Component } from 'react'

class BuyPricePromozioneVertical extends Component {
  render() {
    const valueClassName = this.props.valueClassName
      ? this.props.valueClassName
      : `${this.props.numberOrText} ${
          this.props.isFreePrice ? 'free-price' : ''
        }`

    const prezzoLogisticaStyled = (
      <span className={'price-promo-wrapper'}>
        {this.props.promoLabel ? (
          <span className="label-promo">{this.props.promoLabel}</span>
        ) : null}
        <span>{this.props.prezzoLogisticaPromozione}</span>
      </span>
    )

    const value = this.props.value
      ? this.props.value
      : this.props.prezzoLogistica

    const promoStrikeThrough = {
      textDecoration: 'line-through',
      textDecorationThickness: '2px',
    }
    const logisticsPrice = this.props.prezzoLogistica
      ? this.props.prezzoLogistica
      : value
    let logisticsPriceCssClass = 'full-price-right'

    if (logisticsPrice === 'Incluso') {
      logisticsPriceCssClass += ' color-coral'
    }

    const discount = (
      <span className={valueClassName}>
        <div className={'full-price-wrapper'}>
          <span className={'full-price-left'}>{this.props.fullPriceLabel}</span>
          <span
            className={logisticsPriceCssClass}
            style={this.props.prezzoLogisticaPromozione && promoStrikeThrough}
          >
            {logisticsPrice === 'Incluso' ? 'Gratuito' : logisticsPrice}
          </span>
        </div>
        {this.props.prezzoLogisticaPromozione ? prezzoLogisticaStyled : null}
      </span>
    )

    return this.props.prezzoLogisticaPromozione !==
      this.props.prezzoLogistica ? (
      discount
    ) : (
      <span className={valueClassName}>
        {this.props.prezzoLogisticaPromozione ? (
          <div className={'full-price-wrapper'}>
            <span className={'full-price-left'}>
              {this.props.fullPriceLabel}
            </span>
            <span className={'full-price-right'}>
              {this.props.prezzoLogisticaPromozione}
            </span>
          </div>
        ) : (
          value
        )}
      </span>
    )
  }
}

BuyPricePromozioneVertical.defaultProps = {
  promoLabel: 'In promozione',
  fullPriceLabel: 'Costo del servizio',
}

BuyPricePromozioneVertical.propTypes = {
  valueClassName: PropTypes.string,
  value: PropTypes.string,
  numberOrText: PropTypes.string,
  isFreePrice: PropTypes.bool,
  prezzoLogisticaPromozione: PropTypes.string,
  prezzoLogistica: PropTypes.string,
  promoLabel: PropTypes.string,
  fullPriceLabel: PropTypes.string,
}

export default BuyPricePromozioneVertical
